<template>
  <div>
    <h2 class="box__title">{{ $t('accountSettings.title') }}</h2>
    <Error :error="error"></Error>
    <Alert v-if="success" type="success">
      <template #title>{{ $t('accountSettings.changedTitle') }}</template>
      <p>{{ $t('accountSettings.changedDescription') }}</p>
    </Alert>
    <AccountForm :default-values="user" @submitted="submitted">
      <div class="actions actions--right">
        <Button
          type="primary"
          size="large"
          :loading="loading"
          :disabled="loading"
        >
          {{ $t('accountSettings.submitButton') }}
        </Button>
      </div>
    </AccountForm>
    <!-- Origem Flow: escolha do tema do app (linha 18 da tabela de
         ajustes) — aplica na hora, sem botão de salvar. -->
    <h2 class="box__title margin-top-3">
      {{ $t('accountSettings.themeTitle') }}
    </h2>
    <FormGroup :help-text="$t('accountSettings.themeDescription')">
      <RadioGroup
        v-model="selectedTheme"
        :options="themeOptions"
        vertical-layout
      >
      </RadioGroup>
    </FormGroup>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import error from '@baserow/modules/core/mixins/error'
import AccountForm from '@baserow/modules/core/components/settings/AccountForm'

export default {
  components: { AccountForm },
  mixins: [error],
  data() {
    return {
      loading: false,
      success: false,
      // Origem Flow: tema escolhido ('dark-theme' | 'light-theme' |
      // 'system'); aplicado na hora via plugin $theme.
      selectedTheme: 'dark-theme',
    }
  },
  computed: {
    ...mapGetters({
      user: 'auth/getUserObject',
    }),
    themeOptions() {
      return [
        {
          label: this.$t('accountSettings.themeDark'),
          value: 'dark-theme',
        },
        {
          label: this.$t('accountSettings.themeLight'),
          value: 'light-theme',
        },
        {
          label: this.$t('accountSettings.themeSystem'),
          value: 'system',
        },
      ]
    },
  },
  watch: {
    selectedTheme(theme) {
      if (this.$theme) {
        this.$theme.set(theme)
      }
    },
  },
  mounted() {
    if (import.meta.client && this.$theme) {
      this.selectedTheme = this.$theme.get()
    }
  },
  methods: {
    async submitted(values) {
      this.success = false
      this.loading = true
      this.hideError()

      try {
        const data = await this.$store.dispatch('auth/update', values)
        this.$i18n.setLocale(data.language)
        this.success = true
        this.loading = false
      } catch (error) {
        this.loading = false
        this.handleError(error)
      }
    },
  },
}
</script>
